/**
 * @flow
 */
'use strict';

export const gonioscopyLensCodes = [
{"code":"3 Mirror"},
{"code":"4 Mirror"}
]

export const irisPaternCodes = [
{"code":"Flat"},
{"code":"Concave"},
{"code":"Convex"}
]

export const gonioPigmentCodes = [
{"code":"1+"},
{"code":"2+"},
{"code":"3+"},
{"code":"4+"}
]

export const gonioInsertionCodes = [
{"code":"CB"},
{"code":"TM"},
{"code":"SS"},
{"code":"SL"}
]
